export const GET_DISTRIBUTORS = 'GET_DISTRIBUTORS'
export const GET_DISTRIBUTORS_SUCCESS = 'GET_DISTRIBUTORS_SUCCESS'
export const GET_DISTRIBUTORS_FAILED = 'GET_DISTRIBUTORS_FAILED'

export const GET_DISTRIBUTOR = 'GET_DISTRIBUTOR'
export const GET_DISTRIBUTOR_SUCCESS = 'GET_DISTRIBUTOR_SUCCESS'
export const GET_DISTRIBUTOR_FAILED = 'GET_DISTRIBUTOR_FAILED'

export const CREATE_DISTRIBUTOR = 'CREATE_DISTRIBUTOR'
export const CREATE_DISTRIBUTOR_SUCCESS = 'CREATE_DISTRIBUTOR_SUCCESS'
export const CREATE_DISTRIBUTOR_FAILED = 'CREATE_DISTRIBUTOR_FAILED'

export const UPDATE_DISTRIBUTOR = 'UPDATE_DISTRIBUTOR'
export const UPDATE_DISTRIBUTOR_SUCCESS = 'UPDATE_DISTRIBUTOR_SUCCESS'
export const UPDATE_DISTRIBUTOR_FAILED = 'UPDATE_DISTRIBUTOR_FAILED'

export const FORM_DISTRIBUTOR_ADD = 'FORM_DISTRIBUTOR_ADD'
export const FORM_DISTRIBUTOR_EDIT = 'FORM_DISTRIBUTOR_EDIT'

export const GET_HAYNES_CUSTOMER_BY_CLIENT_ID = 'GET_HAYNES_CUSTOMER_BY_CLIENT_ID'
export const GET_HAYNES_CUSTOMER_BY_CLIENT_ID_SUCCESS = 'GET_HAYNES_CUSTOMER_BY_CLIENT_ID_SUCCESS'
export const GET_HAYNES_CUSTOMER_BY_CLIENT_ID_FAILED = 'GET_HAYNES_CUSTOMER_BY_CLIENT_ID_FAILED'

export const GET_HAYNES_CUSTOMER_PARAMS = 'GET_HAYNES_CUSTOMER_PARAMS'
export const GET_HAYNES_CUSTOMER_PARAMS_SUCCESS = 'GET_HAYNES_CUSTOMER_PARAMS_SUCCESS'
export const GET_HAYNES_CUSTOMER_PARAMS_FAILED = 'GET_HAYNES_CUSTOMER_PARAMS_FAILED'

export const POST_NEW_HAYNES_CUSTOMER = 'POST_NEW_HAYNES_CUSTOMER'
export const POST_NEW_HAYNES_CUSTOMER_SUCCESS = 'POST_NEW_HAYNES_CUSTOMER_SUCCESS'
export const POST_NEW_HAYNES_CUSTOMER_FAILED = 'POST_NEW_HAYNES_CUSTOMER_FAILED'

export const POST_NEW_HAYNES_LICENSE = 'POST_NEW_HAYNES_LICENSE'
export const POST_NEW_HAYNES_LICENSE_SUCCESS = 'POST_NEW_HAYNES_LICENSE_SUCCESS'
export const POST_NEW_HAYNES_LICENSE_FAILED = 'POST_NEW_HAYNES_LICENSE_FAILED'

export const GET_HAYNES_LICENSES_BY_CUSTOMER = 'GET_HAYNES_LICENSES_BY_CUSTOMER'
export const GET_HAYNES_LICENSES_BY_CUSTOMER_SUCCESS = 'GET_HAYNES_LICENSES_BY_CUSTOMER_SUCCESS'
export const GET_HAYNES_LICENSES_BY_CUSTOMER_FAILED = 'GET_HAYNES_LICENSES_BY_CUSTOMER_FAILED'

export const GET_EXTERNAL_SYSTEM_FOR_COMPANY = 'GET_EXTERNAL_SYSTEM_FOR_COMPANY'
export const GET_EXTERNAL_SYSTEM_FOR_COMPANY_SUCCESS = 'GET_EXTERNAL_SYSTEM_FOR_COMPANY_SUCCESS'
export const GET_EXTERNAL_SYSTEM_FOR_COMPANY_FAILED = 'GET_EXTERNAL_SYSTEM_FOR_COMPANY_FAILED'

export const POST_TRIGGER_HAYNESPRO_LINKER = 'POST_TRIGGER_HAYNESPRO_LINKER'
export const POST_TRIGGER_HAYNESPRO_LINKER_SUCCESS = 'POST_TRIGGER_HAYNESPRO_LINKER_SUCCESS'
export const POST_TRIGGER_HAYNESPRO_LINKER_FAILED = 'POST_TRIGGER_HAYNESPRO_LINKER_FAILED'

export const GET_HAYNES_VOLT_LICENSES = 'GET_HAYNES_VOLT_LICENSES'
export const GET_HAYNES_VOLT_LICENSES_SUCCESS = 'GET_HAYNES_VOLT_LICENSES_SUCCESS'
export const GET_HAYNES_VOLT_LICENSES_FAILED = 'GET_HAYNES_VOLT_LICENSES_FAILED'
